(function () {
  'use strict';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function initProductBrowser(section) {
    if (!section || section.dataset.mdBrowserInitialized === 'true') return;
    section.dataset.mdBrowserInitialized = 'true';

    var categoryButtons = toArray(section.querySelectorAll('[data-md-category]'));
    var vendorButtons = toArray(section.querySelectorAll('[data-md-vendor]'));
    var activeVendorLabel = section.querySelector('[data-md-active-vendor-label]');
    var mobileVendorLabel = section.querySelector('[data-md-mobile-vendor-label]');
    var activeCategoryLabel = section.querySelector('[data-md-active-category-label]');
    var filterToggle = section.querySelector('[data-md-filter-toggle]');
    var filterContent = section.querySelector('[data-md-filter-content]');
    var vendorToggle = section.querySelector('[data-md-vendor-toggle]');
    var vendorContent = section.querySelector('[data-md-vendor-content]');
    var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 720px)') : null;
    var emptyFilter = section.querySelector('[data-md-filter-empty]');
    var loadMoreButton = section.querySelector('[data-md-load-more]');
    var paginationWrap = section.querySelector('[data-md-pagination]');
    var infiniteStatus = section.querySelector('[data-md-infinite-status]');
    var infiniteSentinel = section.querySelector('[data-md-infinite-sentinel]');
    var panel = section.querySelector('[data-md-panel="all"]');
    var categoryMapElement = section.querySelector('[data-md-category-map]');

    var productsPerPage = parseInt(section.dataset.mdProductsPerPage, 10) || 12;
    var visibleCount = productsPerPage;
    var activeCategoryId = 'all';
    var activeVendorTag = 'all';
    var activeVendorHandle = 'all';
    var allVendorsLabel = section.dataset.mdAllVendorsLabel || 'All suppliers';
    var activeVendorTitle = allVendorsLabel;
    var collectionQueryKey = section.dataset.mdQueryKey || 'collection';
    var enableAnimation = section.dataset.mdEnableAnimation === 'true';
    var categoryMap = {};
    var categorySets = {};

    if (categoryMapElement) {
      try {
        categoryMap = JSON.parse(categoryMapElement.textContent || '{}');
      } catch (error) {
        categoryMap = {};
        if (window.console && console.warn) {
          console.warn('Minidis product browser: invalid category map.', error);
        }
      }
    }

    Object.keys(categoryMap).forEach(function (key) {
      categorySets[key] = new Set((categoryMap[key] || []).map(normalize));
    });

    function isMobileView() {
      return mobileQuery ? mobileQuery.matches : window.innerWidth <= 720;
    }

    function setAccordionState(toggle, content, open) {
      if (!toggle || !content) return;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.classList.toggle('is-open', open);
      content.classList.toggle('is-open', open);
      content.hidden = isMobileView() ? !open : false;
    }

    function syncMobileAccordions() {
      setAccordionState(filterToggle, filterContent, !isMobileView());
      setAccordionState(vendorToggle, vendorContent, !isMobileView());
    }

    function closeMobileAccordion(toggle, content) {
      if (!isMobileView()) return;
      setAccordionState(toggle, content, false);
    }

    function normalize(value) {
      return String(value || '').toLowerCase().trim();
    }

    function slugify(value) {
      return normalize(value)
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function getUrlParam(name) {
      try {
        return new URLSearchParams(window.location.search).get(name);
      } catch (e) {
        return null;
      }
    }

    function getHashFilter() {
      try {
        var hash = String(window.location.hash || '').replace(/^#/, '');
        if (!hash) return null;
        return decodeURIComponent(hash);
      } catch (e) {
        return null;
      }
    }

    function updateUrlFilter(value) {
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete(collectionQueryKey);
        url.searchParams.delete('category');
        url.searchParams.delete('collection_handle');
        url.hash = (!value || value === 'all') ? '' : slugify(value);
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (e) {}
    }

    function getCards() {
      if (!panel) return [];
      return toArray(panel.querySelectorAll('.md-product-card'));
    }

    function matchesCategory(card, categoryId) {
      if (!card) return false;
      var handle = normalize(card.getAttribute('data-product-handle'));
      var set = categorySets[categoryId];
      if (!set) return categoryId === 'all';
      return set.has(handle);
    }

    function matchesVendor(card, vendorTag, vendorHandle) {
      if (!card) return false;
      if (!vendorTag || vendorTag === 'all') return true;

      var productTags = normalize(card.getAttribute('data-tags'));
      var productVendorHandle = normalize(card.getAttribute('data-vendor-handle'));
      var normalizedTag = normalize(vendorTag);
      var normalizedHandle = normalize(vendorHandle);

      if (normalizedTag && productTags.indexOf('|' + normalizedTag + '|') !== -1) return true;
      if (normalizedHandle && productVendorHandle === normalizedHandle) return true;
      return false;
    }

    function getCategoryCards() {
      return getCards().filter(function (card) {
        return matchesCategory(card, activeCategoryId);
      });
    }

    function getFilteredCards() {
      return getCategoryCards().filter(function (card) {
        return matchesVendor(card, activeVendorTag, activeVendorHandle);
      });
    }

    function updateVendorCounts() {
      var cards = getCategoryCards();

      vendorButtons.forEach(function (button) {
        var tag = normalize(button.getAttribute('data-md-vendor-tag'));
        var handle = normalize(button.getAttribute('data-md-vendor-handle'));
        var count = 0;

        if (tag === 'all' || handle === 'all') count = cards.length;
        else cards.forEach(function (card) { if (matchesVendor(card, tag, handle)) count += 1; });

        var countEl = button.querySelector('[data-md-vendor-count]');
        if (countEl) countEl.textContent = count;
        button.classList.toggle('is-empty', count === 0 && tag !== 'all');
      });
    }

    function setActiveVendor(button) {
      if (!button) return;

      activeVendorTag = normalize(button.getAttribute('data-md-vendor-tag')) || 'all';
      activeVendorHandle = normalize(button.getAttribute('data-md-vendor-handle')) || 'all';
      activeVendorTitle = button.getAttribute('data-md-vendor-title') || allVendorsLabel;

      vendorButtons.forEach(function (item) { item.classList.remove('is-active'); });
      button.classList.add('is-active');
      if (activeVendorLabel) activeVendorLabel.textContent = activeVendorTitle;
      if (mobileVendorLabel) mobileVendorLabel.textContent = activeVendorTitle;

      closeMobileAccordion(vendorToggle, vendorContent);
      visibleCount = productsPerPage;
      applyPagination();
    }

    function resetVendorToAll() {
      var allVendorButton = section.querySelector('[data-md-vendor="all"]');
      if (allVendorButton) {
        activeVendorTag = 'all';
        activeVendorHandle = 'all';
        activeVendorTitle = allVendorsLabel;
        vendorButtons.forEach(function (item) { item.classList.remove('is-active'); });
        allVendorButton.classList.add('is-active');
        if (activeVendorLabel) activeVendorLabel.textContent = activeVendorTitle;
        if (mobileVendorLabel) mobileVendorLabel.textContent = activeVendorTitle;
      }
    }

    function applyPagination() {
      var allCards = getCards();
      var filteredCards = getFilteredCards();

      allCards.forEach(function (card) {
        card.hidden = true;
        card.style.display = 'none';
      });

      if (!panel || filteredCards.length === 0) {
        if (paginationWrap) paginationWrap.style.display = 'none';
        if (infiniteStatus) infiniteStatus.style.display = 'none';
        if (emptyFilter) emptyFilter.style.display = 'block';
        return;
      }

      if (emptyFilter) emptyFilter.style.display = 'none';
      if (visibleCount < productsPerPage) visibleCount = productsPerPage;
      if (visibleCount > filteredCards.length) visibleCount = filteredCards.length;

      filteredCards.forEach(function (card, index) {
        if (index < visibleCount) {
          card.hidden = false;
          card.style.display = '';
        }
      });

      if (infiniteStatus) {
        infiniteStatus.style.display = 'block';
        infiniteStatus.textContent = 'Showing ' + visibleCount + ' of ' + filteredCards.length + ' products';
      }
      if (paginationWrap) paginationWrap.style.display = visibleCount < filteredCards.length ? 'flex' : 'none';
    }

    function loadMoreProducts() {
      var filteredCards = getFilteredCards();
      if (!filteredCards.length) return;
      visibleCount = Math.min(visibleCount + productsPerPage, filteredCards.length);
      applyPagination();
    }

    function findCategoryButtonByHandle(requestedHandle) {
      var requested = slugify(requestedHandle);
      if (!requested || requested === 'all') return section.querySelector('[data-md-category="all"]');

      var matchedButton = null;
      categoryButtons.forEach(function (button) {
        if (matchedButton) return;
        var buttonHandle = slugify(button.getAttribute('data-md-category-handle'));
        var buttonTitle = slugify(button.getAttribute('data-md-category-title'));
        var buttonId = normalize(button.getAttribute('data-md-category'));
        if (requested === buttonHandle || requested === buttonTitle || requested === buttonId) matchedButton = button;
      });
      return matchedButton;
    }

    function activateCategory(button, shouldUpdateUrl, shouldResetVendor) {
      if (!button) return;
      var target = button.getAttribute('data-md-category');
      if (!target) return;

      activeCategoryId = target;
      categoryButtons.forEach(function (item) { item.classList.remove('is-active'); });
      button.classList.add('is-active');
      if (panel) panel.classList.add('is-active');

      if (activeCategoryLabel) {
        activeCategoryLabel.textContent = button.getAttribute('data-md-category-title') || button.textContent.trim() || 'All products';
      }

      closeMobileAccordion(filterToggle, filterContent);
      visibleCount = productsPerPage;
      if (shouldResetVendor) resetVendorToAll();
      updateVendorCounts();
      applyPagination();

      if (shouldUpdateUrl) {
        var handle = button.getAttribute('data-md-category-handle') || button.getAttribute('data-md-category-title') || 'all';
        updateUrlFilter(handle);
      }
    }

    if (filterToggle && filterContent) {
      filterToggle.addEventListener('click', function () {
        setAccordionState(filterToggle, filterContent, filterToggle.getAttribute('aria-expanded') !== 'true');
      });
    }
    if (vendorToggle && vendorContent) {
      vendorToggle.addEventListener('click', function () {
        setAccordionState(vendorToggle, vendorContent, vendorToggle.getAttribute('aria-expanded') !== 'true');
      });
    }
    if (mobileQuery && mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncMobileAccordions);
    else if (mobileQuery && mobileQuery.addListener) mobileQuery.addListener(syncMobileAccordions);

    categoryButtons.forEach(function (button) {
      button.addEventListener('click', function () { activateCategory(button, true, true); });
    });
    vendorButtons.forEach(function (button) {
      button.addEventListener('click', function () { setActiveVendor(button); });
    });
    if (loadMoreButton) loadMoreButton.addEventListener('click', loadMoreProducts);

    if ('IntersectionObserver' in window && infiniteSentinel) {
      var infiniteObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) loadMoreProducts(); });
      }, { root: null, rootMargin: '360px 0px 360px 0px', threshold: 0 });
      infiniteObserver.observe(infiniteSentinel);
    }

    if (enableAnimation) {
      var items = toArray(section.querySelectorAll('.md-animate'));
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) { item.classList.add('md-in-view'); });
      } else {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('md-in-view');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15 });
        items.forEach(function (item) { observer.observe(item); });
      }
    }

    syncMobileAccordions();

    var legacyRequestedCategory = getUrlParam(collectionQueryKey) || getUrlParam('category') || getUrlParam('collection_handle');
    var requestedCategory = getHashFilter() || legacyRequestedCategory;
    if (requestedCategory) {
      var requestedButton = findCategoryButtonByHandle(requestedCategory);
      if (requestedButton) {
        activateCategory(requestedButton, false, true);
        if (legacyRequestedCategory) updateUrlFilter(requestedCategory);
      } else {
        updateVendorCounts();
        applyPagination();
      }
    } else {
      var defaultButton = section.querySelector('[data-md-category="all"]');
      if (defaultButton) activateCategory(defaultButton, false, false);
      else { updateVendorCounts(); applyPagination(); }
    }

    section.setAttribute('data-md-browser-ready', 'true');
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('[data-md-product-browser]')) initProductBrowser(scope);
    toArray(scope.querySelectorAll('[data-md-product-browser]')).forEach(initProductBrowser);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
